import { Label } from '@/components/ui/label'
import { Skeleton } from '@/components/ui/skeleton'

type Props = {
  variant?: 'default' | 'compact'
}

export const ProcessResourceFallback = ({ variant }: Props) => (
  <div className="flex items-end gap-4 w-full">
    <div className="w-full">
      <Label>Resource</Label>
      <Skeleton className="h-9 w-full mt-2" />
      {variant === 'default' ? <Skeleton className="h-3 w-[72%] mt-2" /> : null}
    </div>
  </div>
)
